export const BUTTON_ACTIONS_PLAYER_LIST = [
  {
    id: 'mars_player_list_bulk_sendpersonalizedemail',
    key: '1',
    value: 'actions.sendPersonalizedEmail',
    profile: 'mars.player.sendPersonalizedEmail'
  },
  {
    id: 'mars_player_list_bulk_sendStartClassEmail',
    key: '2',
    value: 'actions.sendStartClassEmail',
    profile: 'mars.player.sendStartClassEmail'
  },
  {
    id: 'mars_player_list_bulk_anonymize',
    key: '3',
    value: 'actions.anonymize',
    profile: 'mars.player.anonymize-bulk'
  },
  { id: 'mars_player_list_bulk_cancel', key: '4', value: 'actions.cancel', profile: 'mars.player.cancel-bulk' }
];

export const DEFAULT_LIST_VALUES = {
  aggregates: null,
  filters: {},
  limit: 10,
  page: 1,
  populate: null,
  search: null,
  sort: null,
  $status: null
};

export const DEFAULT_RESPONSE_TABLE = {
  docs: [],
  limit: 10,
  page: 1,
  pages: 1,
  total: 1
};
